<app-wrapper>
  <div class="mb-9">
    <div class="mb-4">
      <div class="row g-3">
        <div class="col-auto">
          <h2>
            <div class="d-inline pe-2 cursor-pointer" (click)="back()" title="Назад">
              <i class="fa-solid fa-arrow-left"></i>
            </div>
            Город
          </h2>
        </div>
        <div class="col-auto flex-grow-1">
        </div>
        <div class="col-auto">
          <button (click)="save()" [disabled]="form.invalid || !model.location" class="btn btn-primary">
            <i class="fa-solid fa-save"></i>&nbsp;Сохранить
          </button>
        </div>
      </div>
    </div>
    <div class="row g-5">
      <div class="col-12">
        <form #form="ngForm" class="card p-4">
          <div class="row">
            <div class="col-12 mb-4">
              <h4>Укажите центр города</h4>
              <div class="map">
                <ya-map [center]="[54.714047178, 20.50126476]" [zoom]="12" (yaclick)="clickmap($event)">
                  @if (model.location) {
                    <ya-placemark
                    [geometry]="[model.location.lat, model.location.lon]"></ya-placemark>
                  }
                </ya-map>
              </div>
            </div>
            <div class="col-12">
              <div class="row">
                <div class="col-md-4 col-lg-3 mb-4">
                  <div class="form-group">
                    <div class="form-floating mb-3">
                      <input type="text" name="name" [(ngModel)]="model.name" class="form-control"
                        required placeholder="Название">
                        <label>Название</label>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-4 col-lg-3 mb-4">
                    <div class="form-group">
                      <div class="form-check form-switch mb-3">
                        <input class="form-check-input" type="checkbox" name="isEnabled"
                          [(ngModel)]="model.isEnabled">
                          <label class="form-check-label">Включен</label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>

      @if (isBusy) {
        <div class="overlay">
          <i class="fa-solid fa-spinner fa-spin"></i>
        </div>
      }
    </app-wrapper>
